import { z } from "zod";

export const compCycleSearchSchema = z.object({
  step: z
    .enum(["configure", "budget", "allocate", "link_reviews", "plan", "review", "rollout"])
    .optional()
    .catch(undefined),
  q: z.string().optional().catch(undefined),
  department: z.string().optional().catch(undefined),
  decision: z
    .enum(["draft", "accepted", "edited", "declined", "pending", "excluded", "locked"])
    .optional()
    .catch(undefined),
});
